import MultiStorecashTile from './MultiStorecashTile'
import SingleStoreCashTile from './SingleStoreCashTile'
import {formatDateToDDMMYYYY as dateFormatter} from '../helpers/dateFormatter'


const StoreCashTile = ({ tileData,singleTtileData,tilesNumber}) => {
   
   const keyValueArray = tilesNumber === 1  && Object.values(singleTtileData)
   const {
    Body_Html,
    Image_Url,
    Image_alt_text,
    Is_Site_wide,
    SiteWideRewardValue,
    amount,
    heading,
    SiteWide_EndDate,
    reward_endDate,
    skuModel
  } = tilesNumber > 1 ? tileData[1] : keyValueArray[1];

  const endDate = dateFormatter(SiteWide_EndDate)
  const rewardEndDate = dateFormatter(reward_endDate)
  const showInOneLine = (!Is_Site_wide && amount === 0) || (Is_Site_wide && SiteWideRewardValue === '')


  const rewardPrice = (amount !== 0 || (SiteWideRewardValue && SiteWideRewardValue !== '')) ? (
    <span className="storecashTile__price"><sup>$</sup> {amount !== 0 ? amount : SiteWideRewardValue} </span> ) : (
    <span className="storecashTile__price-empty"></span> )

    const tileContent = tilesNumber > 1 ?<MultiStorecashTile skuModel={skuModel} rewardPrice={rewardPrice} Image_Url={Image_Url} Image_alt_text={Image_alt_text} heading={heading} Body_Html={Body_Html} endDate={endDate} rewardEndDate={rewardEndDate} reward_endDate={reward_endDate}/>:<SingleStoreCashTile showInOneLine={showInOneLine} skuModel={skuModel} rewardPrice={rewardPrice} Image_Url={Image_Url} Image_alt_text={Image_alt_text} heading={heading} Body_Html={Body_Html} endDate={endDate} rewardEndDate={rewardEndDate} reward_endDate={reward_endDate} />

  return (
    <div className={`${tilesNumber > 1 ? 'storecashTile padd-left-10 padd-5' : 'singleStorecashTile marg-bottom-5 pos-relative'} bg-white border-all border-graylighter radius-4`}
   >
        {tileContent}
    </div>
  );
  
}

export default StoreCashTile;
